import { render } from "./Audited.vue?vue&type=template&id=8705ab8a"
import script from "./Audited.vue?vue&type=script&lang=js"
export * from "./Audited.vue?vue&type=script&lang=js"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__